import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';

const Placeholder = ({ title, message, className, children }) => {
	const classes = classNames(className, 'eform-gtb-placeholder');
	return (
		<div className={classes}>
			<h3 className="eform-gtb-placeholder__title">{title}</h3>
			<div className="eform-gtb-placeholder__message">{message}</div>
			{children ? (
				<div className="eform-gtb-placeholder__control">{children}</div>
			) : null}
		</div>
	);
};
Placeholder.propTypes = {
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	className: PropTypes.string,
	children: PropTypes.node,
};
Placeholder.defaultProps = {
	className: null,
	children: null,
};

export default Placeholder;
